(function () {

    angular
        .module('smartertoolsApp')
        .directive('stCompareToIfRequired', stCompareToIfRequired);

    function stCompareToIfRequired() {
        return {
            require: 'ngModel',
            scope: {otherModelValue: '=stCompareToIfRequired'},
            link: function (scope, element, attributes, ngModel) {
                ngModel.$validators.stCompareTo = function (modelValue) {
                    if (!modelValue && !element.attr('required'))
                        return true;
                    return modelValue == scope.otherModelValue;
                };
                scope.$watch('otherModelValue', () => {
                    ngModel.$validate();
                });
            }
        };
    }

})();